export class ProductType {
  constructor(
    public hash?: string,
    public name?: string
  ) { }

  clone() {
    return new ProductType(
      this.hash,
      this.name
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/product-type.ts